module.exports = __webpack_public_path__ + "static/media/02.ede413b6.jpg";